import { markdownToHtml } from '@app/helpers/markdown.helpers';
import { FaqList } from '@app/models';

const allowedElements = ['p', 'br', 'a', 'strong', 'em', 'ul', 'ol', 'li'];

export function generateListingFaqSchema(faqList?: FaqList) {
    const mainEntity = (faqList ?? [])
        .filter(item => item.question?.trim() && item.answer?.trim())
        .map(item => ({
            '@type': 'Question',
            name: item.question,
            acceptedAnswer: {
                '@type': 'Answer',
                text: markdownToHtml(item.answer, allowedElements),
            },
        }));

    if (!mainEntity.length) {
        return null;
    }

    return {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity,
    };
}
